import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import i18next from '@/lib/i18n';
import { captureClientException } from '@/lib/sentry';
import { Button } from '@/components/ui/button';
import styles from './AppErrorBoundary.module.css';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    captureClientException(error, { componentStack: info.componentStack });
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div className={styles.root}>
          <h1 className="text-heading-l">{i18next.t('common:errors.internalError')}</h1>
          <p className={`text-body-m ${styles.message}`}>
            {i18next.t('common:errors.unexpectedError')}
          </p>
          <Button type="button" onClick={() => window.location.reload()}>
            {i18next.t('common:errors.refreshPage')}
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}
